import { PayloadAction } from '@reduxjs/toolkit';
import { RegistrationSliceState } from '../state';

/**
 * Mark a specific field as edited
 */
export const markFieldAsEdited = (
  state: RegistrationSliceState,
  action: PayloadAction<string>
) => {
  if (!state.editedFields.includes(action.payload)) {
    state.editedFields.push(action.payload);
    state.isEdited = true;
  }
};

/**
 * Mark the registration as saved (clear edited state)
 */
export const markAsSaved = (state: RegistrationSliceState) => {
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Discard all changes and reset to non-edited state
 */
export const discardChanges = (state: RegistrationSliceState) => {
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

/**
 * Set a validation error for a specific field
 */
export const setValidationError = (
  state: RegistrationSliceState,
  action: PayloadAction<{ field: string; error: string }>
) => {
  state.validationErrors[action.payload.field] = action.payload.error;
};

/**
 * Clear a validation error for a specific field
 */
export const clearValidationError = (
  state: RegistrationSliceState,
  action: PayloadAction<string>
) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors = (state: RegistrationSliceState) => {
  state.validationErrors = {};
};
